module.exports = __webpack_public_path__ + "333202c42d3482fa3e4d4f7c36c64495.svg";